class ChannelState {
    constructor() {
        this.listeners = new Set();
    }
}
export class ChannelStateContainer {
    constructor(equals, logger = console) {
        this.equals = equals;
        this.logger = logger;
        this.channelAliases = new Map();
        this.channelStateMap = new Map();
    }
    setSerializedState(state) {
        Object.entries(state.channelAliases).forEach(([key, value]) => {
            this.channelAliases.set(key, value);
        });
        Object.entries(state.channelStateMap).forEach(([key, value]) => {
            this.channelStateMap.set(key, {
                listeners: new Set(),
                data: value,
            });
        });
    }
    getSerializedState() {
        const state = {
            channelAliases: {},
            channelStateMap: {},
        };
        this.channelAliases.forEach((value, key) => {
            state.channelAliases[key] = value;
        });
        this.channelStateMap.forEach((value, key) => {
            state.channelStateMap[key] = value.data;
        });
        return state;
    }
    createMultiChannel(channelIds) {
        const multiChannelId = this.getMultiChannelId(channelIds);
        const existing = this.channelStateMap.get(multiChannelId);
        if (existing) {
            return multiChannelId;
        }
        channelIds.forEach((channelId) => {
            const existingMultiChannelId = this.channelAliases.get(channelId);
            if (Boolean(existingMultiChannelId) &&
                existingMultiChannelId !== multiChannelId) {
                this.logger.warn("overwriting existing channel alias ", existingMultiChannelId, " with ", multiChannelId, " for ", channelId);
            }
            this.channelAliases.set(channelId, multiChannelId);
        });
        this.getOrCreate(multiChannelId);
        return multiChannelId;
    }
    cleanUp(channelId) {
        this.channelStateMap.delete(channelId);
        for (const alias of this.channelAliases.entries()) {
            if (alias[1] === channelId) {
                this.channelAliases.delete(alias[0]);
            }
        }
    }
    hasChannel(channelId) {
        return this.channelStateMap.has(channelId);
    }
    hasAliasChannel(channelId) {
        return this.channelAliases.has(channelId);
    }
    addListener(channelId, listener) {
        this.getState(channelId).listeners.add(listener);
        return () => this.getState(channelId).listeners.delete(listener);
    }
    get(channelId) {
        return this.getState(channelId).data;
    }
    set(channelId, data) {
        const state = this.getState(channelId);
        const oldData = state.data;
        if (this.equals(state.data, data)) {
            return;
        }
        state.data = data;
        state.listeners.forEach((listener) => listener(data, oldData));
    }
    getState(channelId) {
        const actualChannelId = this.getActualChannelId(channelId);
        return this.getOrCreate(actualChannelId);
    }
    getOrCreate(channeldId) {
        const existing = this.channelStateMap.get(channeldId);
        if (existing) {
            return existing;
        }
        const state = new ChannelState();
        this.channelStateMap.set(channeldId, state);
        return state;
    }
    getActualChannelId(channelId) {
        const mappedChannelId = this.channelAliases.get(channelId) || channelId;
        return mappedChannelId;
    }
    getMultiChannelId(channelIds) {
        return channelIds.join("-");
    }
}
